import Head from "next/head";
import Link from "next/link";

function ListItem({ children }) {
	return <div className="mt-6">{children}</div>;
}

export default function Roadmap() {
	return (
		<>
			<Head>
				<title key="title">Roadmap | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">Roadmap</h1>
				<div className="text-lg leading-7 mt-5">
					<ListItem>
						<a href="http://dec13.io/" rel="noreferrer" target="_blank">
							SEED Date Painting
						</a>{" "}
						<br />
						Feb 2022
					</ListItem>
					<ListItem>
						SEEDs Public Mint <br /> 02.10.22
					</ListItem>
					<ListItem>
						Sara Rabin X Woolrich X Serving The People Tee <br /> 02.18.22
					</ListItem>
					<ListItem>
						STP X Casa CIPRIANI <br /> March 2022
					</ListItem>
					<ListItem>
						Serving<sup>(TM)</sup> Clothing Brand Launch <br /> March 2022
					</ListItem>
					<ListItem>
						SEEDs Phase 2 Planting (Metaverse)
						<br /> April 2022
					</ListItem>
					<ListItem>
						STP Podcasts Channel <br /> Spring 2022
					</ListItem>
					<ListItem>
						STP Platform (Beta) <br /> Summer 2022
					</ListItem>
					<ListItem>
						Woolrich by Serving The People FW 22 Collection <br /> Nov 2022
					</ListItem>
					<ListItem>
						Serving The People Japan Tour <br /> Oct 2022
					</ListItem>
					<ListItem>
						STP Magazine Launch <br /> Oct 2022
					</ListItem>
					<ListItem>
						STP Token <br /> 2023
					</ListItem>
					<ListItem>
						STP DAO <br /> 2023
					</ListItem>
				</div>
			</div>
		</>
	);
}
